import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { FC, useMemo } from 'react';
import { enumKeyByValue } from '@app/shared/helpers';
import {
  WaterfallSectionsErf,
  WaterfallSections,
} from '@app/shared/models/contracts/enums/shared-enums';
import classNames from 'classnames';
import { WaterfallTableExpandableRow } from '@app/modules/projects/outputs/pwerm2-summary-waterfall/waterfall-table/WaterfallTableExpandableRow';
import { WaterfallPartialTableProps } from '../waterfall-table/waterfall-shared';
import { useLocale } from '@app/core/hooks/useLocale';
import { hasInterimTransactions } from '@app/core/store/pwerm2-calculation-slice-selectors';
import useTogglerPwermWaterfall from '@app/core/hooks/useTogglerPwermWaterfall';
import ExitEquitySection from './ExitEquitySection';
import TotalEquitySection from './TotalEquitySection';
import InterimCashFlowsSection from './InterimCashFlowsSection';

export const Pwerm2WaterfallCrossCheckPartialTable: FC<WaterfallPartialTableProps> = ({
  columnsCount,
}): JSX.Element => {
  const results = useAppSelector((state) => state.pwerm2Calculation.calculatedResults);
  const { l } = useLocale();
  const pwermWaterfallTableStates = useAppSelector(
    (state) => state.uiValues.pwermWaterfallTableExpandStates
  );
  const { handleToggle } = useTogglerPwermWaterfall(WaterfallSectionsErf.TotalEquityDCFCrossCheck);
  const hasAnyInterimTransactions = useMemo(() => hasInterimTransactions(results), [results]);

  return (
    <>
      <tbody data-testid="cross-check-expandable-row">
        <WaterfallTableExpandableRow
          title={l('_TotalEquityDCFCrossCheck')}
          id={enumKeyByValue(WaterfallSections, WaterfallSections.TotalEquityDCFCrossCheck)}
          isOpen={pwermWaterfallTableStates[WaterfallSectionsErf.TotalEquityDCFCrossCheck]}
          setIsOpen={handleToggle}
          colCount={columnsCount}
        />
      </tbody>

      <tbody
        className={classNames('table-primary__table-section', {
          'table-primary__table-section--collapsed':
            !pwermWaterfallTableStates[WaterfallSectionsErf.TotalEquityDCFCrossCheck],
        })}
        data-testid="cross-check-section">
        {hasAnyInterimTransactions && <InterimCashFlowsSection columnsCount={columnsCount} />}
        <ExitEquitySection columnsCount={columnsCount} />
        <TotalEquitySection columnsCount={columnsCount} />
      </tbody>
    </>
  );
};
